import { render, staticRenderFns } from "./OrderTemplate.vue?vue&type=template&id=7443f04e"
import script from "./OrderTemplate.vue?vue&type=script&lang=js"
export * from "./OrderTemplate.vue?vue&type=script&lang=js"
import style0 from "./OrderTemplate.vue?vue&type=style&index=0&id=7443f04e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports